import React from 'react';
import { ArrowRightIcon, BookOpenIcon, EyeIcon, FlowerIcon, KeyRoundIcon, SmartphoneIcon, ZapIcon } from 'lucide-react';
import { Section } from './Shared';
import { Daisy, Sprig } from './FloralDecor';
const mapCover = 'https://cdn.magicpatterns.com/uploads/1PfFKaKAMcEcehDW1p2hUL/Mapa_de_las_38_flores_de_Bach-8.png';
const mapFeatures = [{
  icon: KeyRoundIcon,
  text: 'Parole chiave dei 38 rimedi.'
}, {
  icon: FlowerIcon,
  text: 'Organizzazione nei sette gruppi tradizionali.'
}, {
  icon: ZapIcon,
  text: 'Differenze rapide tra fiori simili.'
}, {
  icon: EyeIcon,
  text: 'Tutti i rimedi in una panoramica iniziale.'
}, {
  icon: BookOpenIcon,
  text: 'Indice alfabetico di consultazione.'
}, {
  icon: SmartphoneIcon,
  text: 'Da consultare su smartphone, tablet o stampare.'
}];
const flow = ['Ascolta', 'Confronta', 'Approfondisci', 'Personalizza'];
export function QuickMap() {
  return <Section className="max-w-6xl" data-id="element-298" data-mp="21nmil7p4abes">
      <div className="relative overflow-hidden rounded-xl border border-rose-200 bg-rose-50/60 p-6 md:p-10 lg:p-12" data-id="element-299" data-mp="21ml5yysgdguy">
        <Sprig className="pointer-events-none absolute -right-6 -top-6 h-56 w-32 text-emerald-600/15" data-id="element-300" data-mp="34kaivtxci6a9" />
        <Daisy className="pointer-events-none absolute -bottom-4 -left-4 h-20 w-20" petalClassName="text-white" centerClassName="text-amber-300" data-id="element-301" data-mp="2zlh47y6bo98i" />
        <div className="relative grid items-center gap-8 lg:grid-cols-[2fr_3fr] lg:gap-12" data-id="element-302" data-mp="39h0v26614hqe">
          <div className="mx-auto w-full max-w-xs lg:max-w-sm" data-id="element-303" data-mp="2lqwwid7p7869">
            <img src={mapCover} alt="Copertina della Mappa Rapida dei 38 Fiori di Bach: parole chiave, gruppi e confronti" loading="lazy" className="h-auto w-full rounded-md shadow-xl ring-2 ring-amber-300/80" draggable={false} data-id="element-304" data-mp="2lpc3wt4y1zb1" />
          </div>

          <div data-id="element-305" data-mp="2ps8m4iqknteg">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-rose-700 px-3 py-1 text-xs font-bold tracking-wide text-white" data-id="element-306" data-mp="2prqkt7p1yozo">
              <FlowerIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-307" data-mp="1y23ymb7imq90" />
              NUOVO STRUMENTO INCLUSO
            </span>
            <h2 className="mt-4 text-2xl font-bold tracking-tight text-emerald-900 md:text-4xl" data-id="element-308" data-mp="129fakli53xt">
              Mappa Rapida dei 38 Fiori di Bach
            </h2>
            <p className="mt-3 text-base font-semibold text-rose-700 md:text-lg" data-id="element-309" data-mp="5y81q2n9sbvl">
              I 38 rimedi. Le parole chiave. Tutto in un riferimento visivo.
            </p>
            <p className="mt-3 text-base leading-relaxed text-stone-700" data-id="element-310" data-mp="fpm36fys7lrd">
              Una guida progettata per aiutarti a trovare, confrontare e ricordare le descrizioni tradizionali senza
              cercare ogni volta tra pagine di teoria.
            </p>

            <ul className="mt-6 grid gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-311" data-mp="3o5xmybe70bpu">
              {mapFeatures.map(({
              icon: Icon,
              text
            }) => <li key={text} className="flex gap-2.5 text-sm leading-snug text-stone-900" data-id="element-312" data-mp="3t2xm02cmke7g">
                  <Icon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-700" aria-hidden="true" data-id="element-313" data-mp="13i2qb4xdm3xj" />
                  {text}
                </li>)}
            </ul>

            <ol className="mt-7 flex flex-wrap items-center gap-x-2 gap-y-2 border-t border-rose-200 pt-6" data-id="element-314" data-mp="2svsgp6mdirmo">
              {flow.map((step, index) => <li key={step} className="flex items-center gap-2" data-id="element-315" data-mp="2o03o5n8ruazv" data-mpi={index}>
                  <span className="rounded-md bg-emerald-800 px-3 py-1.5 text-xs font-bold tracking-wide text-amber-200 md:text-sm" data-id="element-316" data-mp="2j5zg10nrrwx7">
                    {step.toUpperCase()}
                  </span>
                  {index < flow.length - 1 && <ArrowRightIcon className="h-4 w-4 text-amber-700" aria-hidden="true" data-id="element-317" data-mp="29707rj6x23aq" />}
                </li>)}
            </ol>
            <p className="mt-4 text-sm font-semibold text-emerald-700" data-id="element-318" data-mp="2086dw0kyzr0v">8 pagine incluse senza costi aggiuntivi.</p>
          </div>
        </div>
      </div>

      <p className="mx-auto mt-8 max-w-2xl text-center text-base font-medium text-stone-700 md:text-lg" data-id="element-319" data-mp="1vawjs7mmyr6p">
        Tutti i bonus e la nuova mappa fanno parte del tuo{' '}
        <span className="font-semibold text-emerald-800" data-id="element-320" data-mp="3poe7bun1jo1q">Kit Completo Fiori di Bach™</span>.
      </p>
    </Section>;
}